/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/nav.
 *
 * Empty means the CMS has no visible nav items. The Navbar treats that
 * as "use the compiled-in default" so an accidentally emptied menu never
 * leaves the public site without a header.
 */

import type { NavItem } from '@/content/nav-types'

export type { NavItem }

export const cmsNav: NavItem[] = [
  {
    "id": 1,
    "label": {},
    "i18n_key": "nav.about",
    "link_kind": "internal",
    "href": "/about",
    "source": null,
    "source_filter": {},
    "open_new_tab": false,
    "children": []
  },
  {
    "id": 2,
    "label": {},
    "i18n_key": "nav.products",
    "link_kind": "internal",
    "href": "/products",
    "source": null,
    "source_filter": {},
    "open_new_tab": false,
    "children": []
  },
  {
    "id": 3,
    "label": {},
    "i18n_key": "nav.magazine",
    "link_kind": "internal",
    "href": "/magazine",
    "source": null,
    "source_filter": {},
    "open_new_tab": false,
    "children": []
  },
  {
    "id": 4,
    "label": {},
    "i18n_key": "nav.lectures",
    "link_kind": "internal",
    "href": "/lectures",
    "source": null,
    "source_filter": {},
    "open_new_tab": false,
    "children": []
  },
  {
    "id": 5,
    "label": {},
    "i18n_key": "nav.articles",
    "link_kind": "collection",
    "href": "/articles",
    "source": "articles",
    "source_filter": {
      "limit": 3
    },
    "open_new_tab": false,
    "children": []
  },
  {
    "id": 6,
    "label": {},
    "i18n_key": "nav.contact",
    "link_kind": "internal",
    "href": "/contact",
    "source": null,
    "source_filter": {},
    "open_new_tab": false,
    "children": []
  }
]
